module.exports = __webpack_public_path__ + "img/Liefern_anywhere_1.93fff3fe.png";